import React from 'react';

export const Printer = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_1_816)'>
                <path
                    d='M5 7.49996V1.66663H15V7.49996'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.99996 15H3.33329C2.89127 15 2.46734 14.8244 2.15478 14.5118C1.84222 14.1993 1.66663 13.7754 1.66663 13.3333V9.16667C1.66663 8.72464 1.84222 8.30072 2.15478 7.98816C2.46734 7.6756 2.89127 7.5 3.33329 7.5H16.6666C17.1087 7.5 17.5326 7.6756 17.8451 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V13.3333C18.3333 13.7754 18.1577 14.1993 17.8451 14.5118C17.5326 14.8244 17.1087 15 16.6666 15H15'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M15 11.6666H5V18.3333H15V11.6666Z'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_1_816'>
                    <rect
                        width='20'
                        height='20'
                        fill='none'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Printer;
